export const hasMath = (content: string) => Boolean(content.match(TEX_REGEX));

export const TEX_REGEX =
  /(?<!\\)(?:\$\$(?:[^$]|\$(?!\$))*?\$\$|\\\[(?:[^\\\]]|\\(?!\])|\](?!\\))*?\\\]|\$(?:[^$]|\\\$)*?\$(?=\s|$|[^\w])|\\\(.*?\\\))/g;
